export const locale = {
    lang: 'ds',
    data: {
        'TITLE': {
        },
        'FIELDS': {
            'ProjectsCoworkerRate': 'Projekt kollega pris',
        },
        'Message': {

        },
        'FILTERS': {
        },
        'Buttons': {
            'Save':'Gem',
        }
    }
};